// extracted by mini-css-extract-plugin
export default {"column":"styles_column__-rPrj","legend":"styles_legend__mwWrh","legend__articles":"styles_legend__articles__qao7A"};